import React from "react";
import { createTheme, ThemeProvider } from "@mui/material";
import { useCookies } from 'react-cookie';

const ColorModeContext = React.createContext({
  toggleColorMode: () => { },
  mode: null

});

export function MaterialThemeProvider(props) {
  const { children }          = props;
  const [cookies, setCookie]  = useCookies(['themeMode']);
  const [mode, setMode]       = React.useState(!cookies['themeMode'] ? 'light' : cookies['themeMode']);


  const lightMode = {
    mode,
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#314F81",
      // dark: will be calculated from palette.primary.main,
      // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
    },
    secondary: {
      // light: will be calculated from palette.primary.main,
      main: "#FCA044",
      // dark: will be calculated from palette.primary.main,
      // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
    },
    error: {
      // light: will be calculated from palette.primary.main,
      main: "#f018a6",
      // dark: will be calculated from palette.primary.main,
      // contrastText: "#fff" //will be calculated to contrast with palette.primary.main
    }
  }

  const darkMode = {
    mode,

  }


  const theme = React.useMemo(
    () =>
      createTheme({
        typography: {
          fontSize: 12,
          fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
          ].join(','),
        },
        palette: mode === 'light' ? lightMode : darkMode,
        breakpoints: {
          values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
            "1xl": 2100,
            "2xl": 2400,
            "3xl": 3000,
            "4xl": 3100
          },
        },
      }),
    [mode],
  );

  const toggleNightMode = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
    setCookie('themeMode', mode === 'light' ? 'dark' : 'light', { path: '/' });
  }

  return (
    <ColorModeContext.Provider value={{ toggleNightMode, palette: { mode } }}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}


export const switchColorMode = () => React.useContext(ColorModeContext);
